module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_SL-3eb5b7695118881d82a18ea6d316931f.svg";